import { render, staticRenderFns } from "./Sliding.vue?vue&type=template&id=5fd21ace&"
import script from "./Sliding.vue?vue&type=script&lang=js&"
export * from "./Sliding.vue?vue&type=script&lang=js&"
import style0 from "./Sliding.vue?vue&type=style&index=0&id=5fd21ace&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports